import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { API_ENDPOINTS } from '../constants/api-endpoints';

export interface MealOrderedReportRequest {
  programId: number;
  fromDate: string;
  toDate: string;
  locationId?: string | null;
}

export interface MealOrderedReportCell {
  locationId?: string | null;
  locationName: string;
  date: string;
  ordered: number;
  delivered: number;
  capacity: number;
}

export interface MealOrderedReportResponse {
  statusCode: number;
  message: string;
  capacity: number;
  fromDate: string;
  toDate: string;
  cells: MealOrderedReportCell[];
}

@Injectable({
  providedIn: 'root',
})
export class MealOrderedReportService {
  private readonly apiService = inject(ApiService);

  getReport(request: MealOrderedReportRequest): Observable<MealOrderedReportResponse> {
    return this.apiService.post<MealOrderedReportResponse>(
      API_ENDPOINTS.REPORTS.MEALS_ORDERED,
      request,
    );
  }
}
